<script setup lang="ts">
import moment from 'moment';
import { useEquipStore } from '~/store/equipStore';
import { useTocStore } from '~/store/tocStore';
import { SitePageInfo } from '~/models/dto-types';
import baseComponent from '../pages/design-toc/component/base-component.vue';
// Images
import userIcon from "@/assets/images/renewal/blank_user.png";
import { useUserStore } from '~/store/userStore';

import DefaultLogo from "@/assets/images/logo.svg";

/** 테스트용 변수 설정 */
const tocStore = useTocStore();
const equipStore = useEquipStore();
const userStore = useUserStore();
const router = useRouter();
const route = useRoute();

const pageType = ref('dashboard');

const slide = ref();


const eventRtuList = ref(await tocStore.tocDashboarEventData('rtu') ?? []);
const eventEquipList = ref(await tocStore.tocDashboarEventData('equip') ?? []);

const nowTime = ref(moment());

const eventPopupOpen = ref(false);

const eventInterval = ref();

const isLogined = computed(() => userStore.loginUserInfo);

const logoImageFile = ref<string | null>(null);


const isDrgeoSite = computed(() => (tocStore.selectSiteInfo as any)?.engSourceKind === 'drgeo');
const isSitePage = computed(() => {
  const name = (route.name ?? '').toString();
  // 작업자의견: 사이트 대시보드 화면에서만 적용
  return name === 'sites-detail-default' || name === 'sites-detail-default-equip-equipid' || name === 'dashboard-site-default-equip-equipid';
});

const currentSiteId = computed(() => {
  const s: any = tocStore.selectSiteInfo as any;
  // 사이트 개인화/타이틀 기준은 siteId로 통일 (cid와 혼용 시 이전 사이트 값이 남는 문제 발생 가능)
  return (s?.siteId ?? null) as string | null;
});

function getSitePersonalization() {
  const siteId = currentSiteId.value;
  const cached = siteId ? ((tocStore.sitePersonalizationCache as any)?.value?.[siteId] as any) : null;
  const sel: any = tocStore.selectSiteInfo as any;
  const siteTitle = (cached?.siteSysTitle ?? sel?.siteSysTitle ?? null) as string | null;
  const attachPath = (cached?.attachPath ?? sel?.attachPath ?? null) as string | null;
  const attachName = (cached?.attachName ?? sel?.attachName ?? null) as string | null;
  // 표시 여부 변수는 API 응답을 참조(필드명이 환경마다 다를 수 있어 방어적으로)
  const enabled =
    (cached?.enabled ?? sel?.personalizationEnabled ?? sel?.enabled ?? sel?.useYn ?? null) as boolean | null;
  return { siteTitle, attachPath, attachName, enabled };
}

const userTitle = computed(() => userStore.loginUserInfo?.personalTitle);
const userLogoPath = computed(() => userStore.loginUserInfo?.personalLogoPath);

const headerTitle = computed(() => {
  console.log(isSitePage.value, isDrgeoSite.value);
  // 작업자의견: 사이트 화면 && engSourceKind=drgeo일 때만 사이트 타이틀 적용
  if (isSitePage.value && isDrgeoSite.value) {
    const { siteTitle } = getSitePersonalization();
    console.log(siteTitle);
    const title = (siteTitle ?? '').trim();
    return title ? title : '통합관제시스템'; 
  }
  // 그 외에는 기존 타이틀
  return !userTitle.value ? '통합관제시스템' : userTitle.value;
});

const headerLogoSrc = computed(() => {
  // 요구사항: 헤더 로고는 "계정 개인 로고"가 있을 때만 적용 (사이트 로고와 무관)
  return (userLogoPath.value && logoImageFile.value) ? logoImageFile.value : DefaultLogo;
});

watch(
  () => userLogoPath.value,
  async (path) => {
    if (path) await makeLogoImg(path, 'user');
  },
  { immediate: true }
);

async function makeLogoImg(url: string | null | undefined, target: 'user'){
  if(url){
    let file = await tocStore.getUserTocSettingImage(url);
    if(file) {
      const objUrl = window.URL.createObjectURL(file);
      if (target === 'user') logoImageFile.value = objUrl;
    }
  }
}


onMounted(() => {
  setInterval(() => {
   nowTime.value = moment();
  }, 1000);

eventInterval.value = setInterval(async () => {
    // null 체크를 할당 전에 수행하여 화면 깜빡임 방지
    const rtuData = await tocStore.tocDashboarEventData('rtu');
    const equipData = await tocStore.tocDashboarEventData('equip');
    
    eventRtuList.value = rtuData ?? [];
    eventEquipList.value = equipData ?? [];
    
  }, 400000)

  document.body.addEventListener('click', dropDownEventFn, false)
  document.body.addEventListener('click', userInfoEventFn, false)
})

onUnmounted(() => {
  clearInterval(eventInterval.value);
})

function eventOpen(e: Event){
  var v = document.querySelector(".toc-notification-popup") as HTMLElement;

  const target = e.target as HTMLElement | null;
  if(!(target?.id === 'dropdownMenuButton' || (target?.parentNode as any)?.id === 'dropdownMenuButton')){
    return;
  }


  if(v.classList.contains('show')){
    v.classList.remove('show');
  } else {
    v.classList.add('show');
  }
}

function userInfoOpen(){
  var v = document.querySelector(".loginDropDown") as HTMLElement;
  if(v.classList.contains('show')){
    v.classList.remove('show');
  } else {
    v.classList.add('show');
  }
}

function checkAllTargetIdClass(eventNode: HTMLElement): boolean{
  let result = false;

  if((eventNode as HTMLElement).id === 'dropdownMenuButton'){
    result = true;
  } else {
    if(eventNode.parentNode){
      result = checkAllTargetIdClass(eventNode.parentNode as HTMLElement);
    } else {
      result = false;
    }
  }

  return result;
}

function userInfoEventFn(e: Event){
  const dropdownContent = document.getElementsByClassName('loginDropDown')[0];

  const target = e.target as HTMLElement | null;
  if(target?.id === 'user-drop-down-btn' || (target?.parentNode as any)?.id === 'user-drop-down-btn'){
    return;
  }

  if(!dropdownContent || !dropdownContent.classList){
    return;
  }

  if(dropdownContent.classList.contains('show')){
    dropdownContent.classList.remove('show')
  }
}

function dropDownEventFn(e: Event){
  const dropdownContent = document.getElementsByClassName('toc-notification-popup')[0];

  const target = e.target as HTMLElement | null;
  if(target?.id === 'dropdownMenuButton' || (target?.parentNode as any)?.id === 'dropdownMenuButton'){
    return;
  }

  if(!dropdownContent || !dropdownContent.classList){
    return;
  }


  if(target && checkAllTargetIdClass(target as HTMLElement)){
    return;
  }

  if(dropdownContent.classList.contains('show')){
    dropdownContent.classList.remove('show')
  }
}

function setClickEvent(event: any){
  // slide.value.toggle(event);
  router.push(`/toc/sites/event/event-detail/${event.cid}?selectEvent={"eventId":"${event.cid}","eventStartDate":"${event.eventStartDate}","eventType":"${event.eventType}"}`)
  const dropdownContent = document.getElementsByClassName('toc-notification-popup')[0];
  dropdownContent.classList.remove('show');
}

async function logout(){
  await userStore.logout();

  router.replace('/toc/user/login');
}

function goFirstPage(){
  const userRoutePermission = userStore.userRoutePermission;
  if(userRoutePermission === 'admin'){
    router.push('/toc/dashboard/default');
  } else if(userRoutePermission === 'equipone'){
    router.push(`/toc/dashboard/site/default/equip/${tocStore.selectEquipInfo.cid}`);
  } else if(userRoutePermission === 'siteone'){
    router.push('/toc/dashboard/sites/default');
  } else if(userRoutePermission === 'siteover'){
    router.push('/toc/dashboard/default');
  } else {
    router.push('/toc/dashboard/default');
  }
}

function goPrivacyService(){
  router.push({name: 'user-privacy-service-user-info'});
}

</script>

<template>
  <div class="toc-design-header">
    
    <div class="logo p-2" >
      <img :src="headerLogoSrc" @click="goFirstPage" :style="{cursor: 'pointer', width: '100%', height: '100%'}"/>
    </div>

    <!------------ SECTION: 헤더 왼쪽 영역 ------------>
    <div class="title" :style="{marginLeft: '10px'}">
      {{ headerTitle }}
    </div>
    <!------------ SECTION: 헤더 오른쪽 영역 ------------>
    <div class="info-wrapper" v-if="isLogined">
      <div class="now-date">
        {{ nowTime.format('YYYY-MM-DD HH:mm:ss') }}
      </div>
      <div class="pointer-section">
        <div class="alarm-wrapper" id="dropdownMenuButton" @click="eventOpen">
          <img src="@/assets/images/renewal/notification.svg"></img>
          <span class="noise" v-if="(eventEquipList?.length ?? 0) + (eventRtuList?.length ?? 0) > 0">{{ (eventEquipList?.length ?? 0) + (eventRtuList?.length ?? 0) }}</span>
          <div class="toc-notification-popup">
            <!-- <div class="title">
              이벤트 현황
            </div> -->

            <ul class="nav nav-tabs nav-fill" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="equipEvent-tab" data-bs-toggle="tab" data-bs-target="#equipEvent-tab-pane" type="button" role="tab" aria-controls="equipEvent-tab-pane" aria-selected="true">설비</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="rtuEvent-tab" data-bs-toggle="tab" data-bs-target="#rtuEvent-tab-pane" type="button" role="tab" aria-controls="rtuEvent-tab-pane" aria-selected="false">RTU</button>
              </li>
            </ul>

            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="equipEvent-tab-pane" role="tabpanel" aria-labelledby="equipEvent-tab" tabindex="0">
                <div class="contents" v-if="eventEquipList?.length > 0">
                  <!------------------ SECTION: EQUIP 이벤트 ------------------>
                  <div class="event-wrapper" v-for="(event, i) in eventEquipList" @click="setClickEvent(event)">
                    <div class="icon">
                      <div class="inIconWrapper event-equip" :class="event.opStatus">
                        <img v-if="event.opStatus" src="@/assets/images/renewal/notification.svg" />
                        <img v-else src="@/assets/images/renewal/notification-off.svg" />
                        <div class="status-eclipse"></div>
                      </div>
                    </div>
                    <div class="txt">
                      <ul>
                        <li class="date">{{ moment(event.eventStartDate).format('YYYY-MM-DD HH:mm A') }}</li>
                        <li class="addr">
                          {{ `${commonUtils.isAllStrDataEmpty(event.ownerName)} - ${commonUtils.isAllStrDataEmpty(event.cid)}` }}
                        </li>
                        <li class="addr">{{ `${event.engSourceName}/${event.opStatusName} - ${commonUtils.setAddrString((event as any).dongName)}`  }}</li>
                        <li class="fault">{{ event.fault ? event.fault : event.eventCode }}</li>
                      </ul>
                    </div>
                  </div>

                </div>
                <!------------------ SECTION: No 이벤트 ------------------>
                <div class="contents" v-else>
                  <div class="non-event">
                    발생한 이벤트가 없습니다.
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="rtuEvent-tab-pane" role="tabpanel" aria-labelledby="rtuEvent-tab" tabindex="0">
                <div class="contents" v-if="eventRtuList?.length > 0">
                  
                  <!------------------ SECTION: RTU 이벤트 ------------------>
                  <div class="event-wrapper" v-for="(event, i) in eventRtuList" @click="setClickEvent(event)">
                    <div class="icon">
                      <div class="inIconWrapper event-rtu">
                        <img src="@/assets/images/renewal/device-type-rtu.png" style="width: 40px; height: 40px;" />

                        <div class="status-eclipse"></div>
                      </div>
                    </div>
                    <div class="txt">
                      <ul>
                        <li class="date">
                          {{ moment(event.eventStartDate).format('YYYY-MM-DD HH:mm A') }}
                        </li>
                        <li class="addr">
                          {{ `${commonUtils.isAllStrDataEmpty(event.ownerName)} - ${commonUtils.isAllStrDataEmpty(event.cid)}` }}
                        </li>
                        <li class="addr">
                          {{ `${event.engSourceName} - ${commonUtils.setAddrString((event as any).dongName)}` }}
                        </li>
                        <li class="fault">
                          {{ event.fault ? event.fault : event.eventCode }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!------------------ SECTION: No 이벤트 ------------------>
                <div class="contents" v-else>
                  <div class="non-event">
                    발생한 이벤트가 없습니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="divider"></div> -->
        <div class="user-info">
          <img class="user-info-icon" id="user-drop-down-btn" :src="userIcon" alt="사용자 이미지" @click="userInfoOpen" />
          <div class="loginDropDown common-card">
            <button class="button" @click="goPrivacyService">내 계정 관리</button>
            <button class="button" @click="logout">로그아웃</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>


<style lang="scss" scoped>
@use "@/assets/styles/design-toc/define_font.scss";
@use "@/assets/styles/design-toc/common-button.scss";
@use "@/assets/styles/design-toc/common-card.scss";

@mixin eclipse-status($bg-color, $type) {
  position: absolute;
  
  @if ($type == 'default') {
    top: 2px;
    right: 2px;
    border: none;
  }
  @else if ($type == 'rotate') {
    top: calc(50% - 3px);
    left: calc(50% - 3px);
    transform: translate(-50%, -50%);
    @include rotate-animation($bg-color);
  }
  @else if ($type == 'pulse') {
    top: 2px;
    right: 2px;
    @include pulse-animation($bg-color);
  } 
  
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: $bg-color !important;
}

@mixin rotate-animation($color) {
  animation: rotate-eclipse 4s linear infinite;
}
@mixin pulse-animation($color) {
  --pulse-color: #{$color};
  animation: pulse-eclipse 3s linear infinite;
}

// NOTE: 파동 이벤트
@keyframes pulse-eclipse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--pulse-color);
  }
  40% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--pulse-color);
  }
  42% {
    transform: scale(1.1);
    box-shadow: 0 0 2px 1px var(--pulse-color);
  }
  45% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--pulse-color);
  }
  47% {
    transform: scale(1.1);
    box-shadow: 0 0 2px 1px var(--pulse-color);
  }
  50% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--pulse-color);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--pulse-color);
  }
}
// NOTE: 회전 이벤트
@keyframes rotate-eclipse {
  0% {
    transform: rotate(0deg) translateX(20px) rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translateX(20px) rotate(-360deg);
  }
}

// NOTE: 이벤트 테두리 스타일
@mixin event-border($color) {
  border: 1px solid $color;
}

.toc-notification-popup {
  position: absolute;
  width: 300px;
  height: 500px;
  top: 35px;
  right: 0;
  background-color: #fff;
  box-shadow: 0 1px 1px 2px rgba(98, 112, 139, 0.2), 0 1px 3px 1px rgba(67, 80, 105, 0.3);
  z-index: 999;
  color: #000;
  border-radius: 6px;
  cursor: default;
  display: none;
  overflow: hidden;

  .tab-content{
    height: calc(100% - 45px);

    .tab-pane{
      height: 100%;
      .contents{
        height: 100%;
        overflow-y: scroll; 
      }
    }

  }

  &.show {
    display: block;
  }

  & .title {
    @include define_font.text-bold-14;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 14px 10px;
    font-weight: 700;
    border-bottom: 1px solid var(--input-border-color);
  }

  & .contents {

    .non-event{
      text-align: center;
      padding: 10px;
      font-size: 18px;
      font-weight: bold;
    }

    &::-webkit-scrollbar {
      width: 4px;
      background-color: var(--main-content-background-color);
      border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--btn-gray-disabled-background-color);
      border-radius: 6px;
    }

    &::-webkit-scrollbar-track {
      background-color: #FFF;
      border-radius: 6px;
    }
    
    & .event-wrapper {
      display: flex;
      align-items: center;
      padding: 0.5rem;
      transition: background-color 0.2s ease;

      &:hover{
        background-color: var(--main-content-background-color);
        cursor: pointer;
      }

      & .icon {
        border: none;

        width: 50px;
        display: flex;
        justify-content: center;
        padding: 5px;
        height: 50px;

        & .inIconWrapper {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 40px;
          border-radius: 100%;
          background-color: #FFF;

          // & .event-rtu {}  // (빈 ruleset 제거)

          img {
            width: 25px;
            height: 25px;
          }
          /**************** NOTE: 기본 이벤트 스타일 ****************/
          & .event-equip {
            img {
              filter: invert(38%) sepia(99%) saturate(2406%) hue-rotate(10deg) brightness(95%) contrast(120%);
            }
            & .status-eclipse {
              display: none;
            }
          }
          /**************** NOTE: normal 스타일 ****************/
          &.normal {
            background-color: #dff7e9;
            
            & img {
              filter: invert(38%) sepia(99%) saturate(2406%) hue-rotate(61deg) brightness(95%) contrast(120%);
            }
            & .status-eclipse {
              @include eclipse-status(#27ae60, "default");
            }
          }
          /**************** NOTE: preparing 스타일 ****************/
          &.preparing {
            background-color: #ddefff;
            & img {
              filter: invert(38%) sepia(99%) saturate(2406%) hue-rotate(184deg) brightness(95%) contrast(80%);
            }
            & .status-eclipse {
              @include eclipse-status(#0084ff, "default");
            }
          }
          /**************** NOTE: warning 스타일 ****************/
          &.warning {
            background-color: #ffefcd;

            & img {
              filter: invert(38%) sepia(99%) saturate(2406%) hue-rotate(4deg) brightness(95%) contrast(120%);
            }
            & .status-eclipse {
              @include eclipse-status(#ffa800, "default");
            }
          }
          /**************** NOTE: fault 스타일 ****************/
          &.fault {
            background-color: #ffdfdf;

            & img {
              filter: invert(38%) sepia(99%) saturate(2406%) hue-rotate(-30deg) brightness(95%) contrast(120%);
            }
            & .status-eclipse {
              @include eclipse-status(#f86565, "pulse"); 
            }
          }
          /**************** NOTE: down 스타일 ****************/
          &.down {
            background-color: #e7e7e7;
            
            & img {
              filter: invert(38%) brightness(95%) contrast(120%);
            }
            & .status-eclipse {
              @include eclipse-status(#a9a9a9, "default");
            }
          }
        }
      }

      & .txt {
        width: 80%;
        padding: 0px 10px;

        & li {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        & .date {
          color: var(--Grey-10, #6B7271);
          /* xxSmall - Regular 10px - Urbanist */
          font-family: Urbanist;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 130%;
        }

        & .addr {
          color: var(--Black, #242E2C);
          /* Title/11px - Medium */
          font-family: Urbanist;
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: 130%; /* 14.3px */
        }

        & .fault {
          color: var(--Black, #242E2C);
          /* Title/11px - Medium */
          font-family: Urbanist;
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: 130%; /* 14.3px */
        }
      }
    }
  }
}

.toc-design-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px 15px 0px;
  color: var(--main-header-text-color);
  // border-left: 1px solid #ffffff73;
  border: none;

  .nav-tabs{
    .nav-item{
      .nav-link{
        &:not(.active){
          background-color: #f5f8ff;
          color: #75767b;
          border-bottom: 3px solid transparent;
        }

        &.active{
          color: #007CE1;
          border-bottom: 3px solid #007ce1;

        }
      }
    }
  }

  & .info-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;

    & .now-date {
      font-size: 14px;
      font-weight: 400;
      color: var(--main-header-text-color);
      margin-right: 2rem;
      text-align: left;
      white-space: nowrap;
    }

    & .pointer-section {
      // width: 100%;
      height: 30px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 8px;

      & > * {
        height: 30px;
      }

      & .alarm-wrapper {
        position: relative;
        width: 30px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #d9d9d9dc;
        border: none;
        border-radius: 100%;
        padding: 5px;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
          background-color: #f8f4d3;
        }

        & img {
          width: 24px;
          height: 24px;
        }

        & .noise {
          position: absolute;
          right: calc(100% - 12px);
          bottom: calc(100% - 12px);
          width: 18px;
          height: 18px;
          line-height: 18px;
          background-color: #f76829;
          border-radius: 100%;
          color: #FFF;
          text-align: center;
          font-size: 10px;
          font-weight: 600;
        }
      }

      & .user-info {
        cursor: pointer;
        display: flex;
        align-items: center;

        & .user-info-icon {
          background-color: #d9d9d942;
          width: 30px;
          height: 30px;
          border-radius: 100%;
        }
        
        & .loginDropDown {
          display: none;
          position: absolute;
          top: 55px;
          right: 10px;
          background-color: var(--active-background-color);
          z-index: 999;
          padding: 0;

          &.show {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2px;
          }

          .button {
            @include define_font.text-normal-14;
            padding: 0;
            margin: 0;
            width: 100%;
            background-color: #FFF;
            padding: 0.5rem 2rem;
            
            &:hover{
              background-color: var(--main-content-background-color);
            }
          }
        }

        // & .caret {
        //   width: 30px;
        //   height: 30px;
        //   background: url("@/assets/images/renewal/user-caret.svg") no-repeat scroll center;
        // }
      }
    }
  }
}
</style>